import { render, staticRenderFns } from "./SecaoCadastroNovo.vue?vue&type=template&id=b341fa12&scoped=true"
import script from "./SecaoCadastroNovo.vue?vue&type=script&lang=js"
export * from "./SecaoCadastroNovo.vue?vue&type=script&lang=js"
import style0 from "./SecaoCadastroNovo.vue?vue&type=style&index=0&id=b341fa12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b341fa12",
  null
  
)

export default component.exports